import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import OrdersList from './pages/OrdersList';
import OrderDetail from './pages/OrderDetail';
import NewOrder from './pages/NewOrder';
import Inventory from './pages/Inventory';
import Clients from './pages/Clients';
import Dispatch from './pages/Dispatch';
import Commissions from './pages/Commissions';
import Reports from './pages/Reports';
import Users from './pages/Users';
import Expenses from './pages/Expenses';
import CreditNotes from './pages/CreditNotes';
import AdminPanel from './pages/AdminPanel';
import './App.css';

// Redirigir si ya está autenticado
const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  if (isAuthenticated) return <Navigate to="/" replace />;
  return children;
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: {
              fontFamily: 'Inter, sans-serif',
              fontSize: '0.85rem',
              borderRadius: '10px',
              padding: '10px 16px',
            },
          }}
        />
        <Routes>
          {/* Login público */}
          <Route
            path="/login"
            element={
              <PublicRoute>
                <Login />
              </PublicRoute>
            }
          />

          {/* Rutas protegidas con Layout */}
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />

            <Route path="ordenes" element={<OrdersList />} />
            <Route path="ordenes/nueva" element={
              <ProtectedRoute roles={['salesman', 'admin']}>
                <NewOrder />
              </ProtectedRoute>
            } />
            <Route path="ordenes/:id" element={<OrderDetail />} />

            <Route path="inventario" element={
              <ProtectedRoute roles={['admin', 'manager', 'warehouse']}>
                <Inventory />
              </ProtectedRoute>
            } />

            <Route path="clientes" element={
              <ProtectedRoute roles={['admin', 'manager', 'salesman']}>
                <Clients />
              </ProtectedRoute>
            } />

            <Route path="despacho" element={
              <ProtectedRoute roles={['admin', 'delivery', 'warehouse']}>
                <Dispatch />
              </ProtectedRoute>
            } />

            <Route path="comisiones" element={
              <ProtectedRoute roles={['admin', 'manager', 'accountant', 'salesman']}>
                <Commissions />
              </ProtectedRoute>
            } />

            <Route path="gastos" element={
              <ProtectedRoute roles={['admin', 'manager', 'accountant']}>
                <Expenses />
              </ProtectedRoute>
            } />

            <Route path="notas-credito" element={
              <ProtectedRoute roles={['admin', 'manager', 'accountant']}>
                <CreditNotes />
              </ProtectedRoute>
            } />

            <Route path="reportes" element={
              <ProtectedRoute roles={['admin', 'manager', 'accountant']}>
                <Reports />
              </ProtectedRoute>
            } />

            <Route path="usuarios" element={
              <ProtectedRoute roles={['admin']}>
                <Users />
              </ProtectedRoute>
            } />

            <Route path="admin" element={
              <ProtectedRoute roles={['admin']}>
                <AdminPanel />
              </ProtectedRoute>
            } />
          </Route>

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
